import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    resedFax,
    useSentListDetails,
    getSendingFaxList,
    getSendingfaxstatus
} from "redux/slice/faxSlice";
import { useAppDispatch } from "redux/hooks";
import {
    setDeleteHide,
    useHideDelete,
    useSentType,
    useStatusfilter,
    useNumber,
    useTab,
    setStatusFilter,
    useShowIncompleteSentFaxes,
    setShowIncompleteSentFaxes,
} from "redux/slice/commanSlice";
import Table from "components/ui-component/Table";
import { message, Typography, Tooltip, Tag, Pagination, FloatButton, Drawer } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import EditDropIcon from "components/Icons/EditDropIcon";
import DeleteThinIcon from "components/Icons/DeleteThinIcon";
import AddIconCollapseIcon from "components/Icons/AddIconCollapse";
import SearchIcon from "components/Icons/SearchIcon";
import {
  FaxPageHeader,
  FaxPageStyle,
  HeaderActions,
  Search,
} from "components/fax/SecureFax.style";
import DownloadIcon from "components/Icons/Download";
import { Button } from "components/ui-component";
import RefreshIcon from "components/Icons/Refresh";
import ResendIcon from "components/Icons/Resend";
import TableCard, { FaxCardDataType } from "components/TableCard/TableCard";
import SinglePlusIcon from "components/Icons/SinglePlusIcon";
import FilterIcon from "components/Icons/FilterIcon";
import SentFaxFilters from "components/fax/SentFaxFilters";
import Lock from "components/Icons/Lock";
import { onGetUserInfo } from "components/Helper/onGetUserInfo";
import { onDownloadFax } from "../Helper/DownloadFile";
import { getFaxStatusColor } from "components/Helper/faxStatusColor";

interface SentFaxProps {
    filter: any;
    setFilter: any;
    setDeleteId: any;
    setSentFaxData: any;
    setIsWarn: any;
    isLoading: boolean;
    setFaxLogs: any;
}

const statusOptions = [
  { value: "all", label: "All Faxes" },
  { value: "delivered", label: "Delivered Faxes" },
  { value: "sending", label: "Sending Faxes" },
  { value: "failed", label: "Failed Faxes" },
];

const SentFax = (props: SentFaxProps) => {
    const {
        setDeleteId,
        setSentFaxData,
        setFilter,
        filter,
        isLoading,
        
    } = props;

    const { user } = useAuth0();
    const navigation = useNavigate();
    const sentFaxList = useSentListDetails();
    const activeTab = useTab();
    const sentType = useSentType();
    const status_filter = useStatusfilter();
    const hide_deleted = useHideDelete();
    const number = useNumber();
    const showIncompleteSentFaxes =  useShowIncompleteSentFaxes();
    const [faxStatusList, setFaxStatusList] = React.useState<any[]>([]);
    const [faxStatusSendingList, setFaxStatusSendingList] = React.useState<any[]>([]);
    const [faxUuids, setFaxUuids] = React.useState<string[]>([]);
    const [filteredFaxes, setFilteredFaxes] = useState<FaxCardDataType[]>([]);
    const [openFilter, setOpenFilter] = useState(false);

    const dispatch = useAppDispatch();

    const showDrawer = () => {
      setOpenFilter(true);
    };

    const onClose = () => {
      setOpenFilter(false);
    };

    useEffect(() => {
        if (sentFaxList?.faxes) {
          const filtered = showIncompleteSentFaxes 
            ? sentFaxList.faxes
            : sentFaxList.faxes.filter((fax: any) => fax.status !== "incomplete");
          const formatedFiltered = filtered?.map((item: FaxCardDataType) => {
            return { ...item, key: item?.uuid };
          });
          setFilteredFaxes(formatedFiltered);
        }
      }, [showIncompleteSentFaxes, sentFaxList]);

    const onResendFax = async (id: string) => {
      onGetUserInfo(dispatch, user, navigation);
        try {
            const res: any = await dispatch(resedFax(id)).unwrap();
            if (res && res.status === "Resend Accepted") {
                message.success("Fax resend queued");
                setFilter({ ...filter });
            } else {
                message.error("Something went wrong");
            }
        } catch (error: any) {
            console.log("fax resend err: --->", error?.message);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            onSendingstatus();
        }, 5000); // 5 seconds
    
        // Clean up the interval on component unmount
        return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (faxUuids.length > 0) {
            const interval = setInterval(() => {
                faxUuids.forEach(async (uuid) => {
                    try {
                        const faxStatus: any = await dispatch(getSendingfaxstatus(uuid)).unwrap();
    
                        const newStatusList = faxStatusList.filter(item => item.uuid !== uuid);
                        if (faxStatus.status !== "sending") {
                            if (faxStatus.status !== "Error") {
                                setFaxUuids(prevUuids => prevUuids.filter(prevUuid => prevUuid !== uuid));
                                setFaxStatusList([...newStatusList, { uuid, status: faxStatus.status, pages: faxStatus.pages_sent }]);
                            } else {
                                setFaxStatusList([...newStatusList, { uuid, status: faxStatus.status, pages: faxStatus.pages_sent }]);
                            }
                        } else {
                            setFaxStatusList([...newStatusList, { uuid, status: faxStatus.status, pages: faxStatus.pages_sent }]);
                        }
                    } catch (error: any) {
                        console.log("Error fetching status for UUID", uuid, ":", error?.message);
                    }
                });
            }, 5000); // 5 seconds
    
            return () => clearInterval(interval);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faxUuids]);


    const onSendingstatus = async () => {
        try {
            let params = {
                ...filter,
                username: user?.email,
                phone_number: number,
                direction: "out",
                status_filter: "sending"
            };
            const sendingfax: any = await dispatch(getSendingFaxList(params)).unwrap();
    
            if (sendingfax && sendingfax.total_faxes > 0) {
                sendingfax.faxes.forEach(async (fax: any) => {
                    if (!faxUuids.includes(fax.uuid)) {
                        const newStatusList = faxStatusList.filter(item => item.uuid !== fax.uuid);
                        setFaxStatusSendingList([...newStatusList, { uuid: fax.uuid, pages: fax.pages }]);
                        setFaxUuids(prevUuids => {
                            if (!prevUuids.includes(fax.uuid)) {
                                return [...prevUuids, fax.uuid];
                            }
                            return prevUuids;
                        })
                    }
                });
            } else {
                setFaxUuids(prevUuids => {
                    // if (!prevUuids.includes(fax.uuid)) {
                    //     return [...prevUuids, fax.uuid];
                    // }
                    return prevUuids;
                })
               
            }
        } catch (error: any) {
            console.log("fax list get error -->", error?.message);
        }
    }

    const columns = [
      {
        title: "From Number",
        dataIndex: "from_number",
        key: "from_number",
        render: (text: string, record: any) => (
          <div className="flex gap-3 items-center from-number-wrapper">
            <label>{text}</label>
            <Tooltip title="To ensure the utmost security and confidentiality, all faxes are individually encrypted using a Key Management Service">
              <span>
                <Lock className="lock" />
              </span>
            </Tooltip>
          </div>
        ),
      },
      {
        title: "To Number",
        dataIndex: "to_number",
        key: "to_number",
      },
      {
        title: "Date",
        dataIndex: "created_on",
        key: "created_on",
      },
      {
        title: "Status",
        key: "status",
        render: (_: any, record: any) => {
          const faxStatus = faxStatusList.find(
            (item) => item.uuid === record.uuid
          );
          const status = faxStatus ? faxStatus.status : record.status;
          const pages = faxStatus ? faxStatus.pages : null;

          return (
            <div className="flex gap-2 items-center">
              <div className="from-number-wrapper">
                <Tag bordered={false} color={getFaxStatusColor(status)}>
                  <span className="capitalize">
                    {status}{" "}
                    {status === "sending" && pages !== null && `(${pages})`}
                  </span>
                </Tag>
                {status === "failed" && (
                  <Button
                    type="text"
                    className="refresh-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      onResendFax(record.uuid);
                    }}
                    icon={
                      <Tooltip title="Retry Sending Fax">
                        <span>
                          <RefreshIcon />
                        </span>
                      </Tooltip>
                    }
                  />
                )}
              </div>
            </div>
          );
        },
      },
      {
        title: "Pages",
        key: "pages",
        render: (_: any, record: any) => {
          const faxStatus = faxStatusSendingList.find(
            (item) => item.uuid === record.uuid
          );
          const pages = faxStatus ? faxStatus.pages : record.pages;

          return <div>{pages}</div>;
        },
      },
      {
        title: "Notes",
        dataIndex: "notes",
        key: "notes",
        render: (text: string, record: any) => (
          <div className="overflow-hidden max-w-full">
            <span
              title={text}
              className="whitespace-normal break-words overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
              }}
            >
              {text}
            </span>
          </div>
        ),
      },
      {
        title: "",
        key: "action",
        fixed: "right" as const,
        render: (_: any, record: any) => (
          <div className="action-wrapper">
            <div className="securefax-action">
              {record?.download_link && (
                <Button
                  type="text"
                  className="securefax-action__list"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDownloadFax(
                      record,
                      record?.download_link,
                      dispatch,
                      user,
                      navigation
                    );
                  }}
                  icon={
                    <Tooltip title="Download Fax">
                      <span>
                        <DownloadIcon />
                      </span>
                    </Tooltip>
                  }
                />
              )}
              <Button
                type="text"
                className="securefax-action__list"
                onClick={(e) => {
                  e.stopPropagation();
                  setSentFaxData(record);
                }}
                icon={
                  <Tooltip title="Edit Fax">
                    <span>
                      <EditDropIcon />
                    </span>
                  </Tooltip>
                }
              />
              <Button
                type="text"
                className="securefax-action__list"
                onClick={(e) => {
                  e.stopPropagation();
                  onResendFax(record?.uuid);
                }}
                icon={
                  <Tooltip title="Resend Fax">
                    <span>
                      <ResendIcon />
                    </span>
                  </Tooltip>
                }
              />
              {record?.status !== "deleted" && (
                <Button
                  type="text"
                  className="securefax-action__list"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(record?.uuid);
                  }}
                  icon={
                    <Tooltip title="Delete Fax">
                      <span>
                        <DeleteThinIcon
                          width="14"
                          height="14"
                          strokeWidth="2"
                        />
                      </span>
                    </Tooltip>
                  }
                />
              )}
            </div>
          </div>
        ),
      },
    ];
    
    const handleChange = (e: any) => {
        const newHideDeleted = hide_deleted === "yes" ? "no" : "yes";
        setFilter({
          ...filter,
          page: 1,
          per_page: 10,
          hide_deleted: newHideDeleted,
        });
        dispatch(setDeleteHide(newHideDeleted));
      };

    return (
      <>
        <FaxPageStyle>
          <FaxPageHeader>
            <Typography.Title level={5}>
              {`Sent Faxes (${sentFaxList?.total_faxes ?? 0})`}
            </Typography.Title>
            <Button
              type="text"
              className="refresh-icon"
              style={{ cursor: "pointer", paddingRight: "12px" }}
              onClick={() => setFilter({ ...filter })}
              icon={<RefreshIcon />}
            />
            <div className="mobile-hide tab-hide">
              <SentFaxFilters
                setFilter={setFilter}
                sentType={sentType}
                activeTab={activeTab}
                status_filter={status_filter}
                statusOptions={statusOptions}
                dispatch={dispatch}
                setStatusFilter={setStatusFilter}
                filter={filter}
                hide_deleted={hide_deleted}
                handleChange={handleChange}
                showIncompleteSentFaxes={showIncompleteSentFaxes}
                setShowIncompleteSentFaxes={setShowIncompleteSentFaxes}
              />
            </div>
            <Drawer
              title="Filter"
              closable={{ "aria-label": "Close Button" }}
              onClose={onClose}
              open={openFilter}
              className="filter-drawer"
            >
              <div className="d-flex flex-direction-columnu gap-y-4 align-items-start">
                <SentFaxFilters
                  setFilter={setFilter}
                  sentType={sentType}
                  activeTab={activeTab}
                  status_filter={status_filter}
                  statusOptions={statusOptions}
                  dispatch={dispatch}
                  setStatusFilter={setStatusFilter}
                  filter={filter}
                  hide_deleted={hide_deleted}
                  handleChange={handleChange}
                  className="date-filter-wrapper"
                  showIncompleteSentFaxes={showIncompleteSentFaxes}
                  setShowIncompleteSentFaxes={setShowIncompleteSentFaxes}
                />
              </div>
            </Drawer>
            <HeaderActions>
              <Button
                type="text"
                className="filter-icon"
                onClick={showDrawer}
                icon={
                  <Tooltip title="Filter">
                    <span>
                      <FilterIcon />
                    </span>
                  </Tooltip>
                }
              />

              <div className="searchbar-wrapper">
                <Search
                  prefix={<SearchIcon />}
                  size="small"
                  placeholder="Search by number or notes"
                  inputMode="search"
                  search={filter?.search_query}
                  value={filter?.search_query ?? ""}
                  onChange={(e: any) => {
                    setFilter({
                      ...filter,
                      search_query: e.target.value,
                    });
                  }}
                  maxLength={50}
                />
              </div>
              <div className="mobile-hide">
                <Button
                  size="small"
                  type="primary"
                  onClick={() => navigation("/fax/compose-fax")}
                  icon={<AddIconCollapseIcon width="20" height="20" />}
                >
                  Compose a fax
                </Button>
              </div>
              <div className="desktop-hide">
                <FloatButton
                  icon={<SinglePlusIcon />}
                  onClick={() => navigation("/fax/compose-fax")}
                />
              </div>
            </HeaderActions>
          </FaxPageHeader>
          <div className="mobile-table-block desktop-hide">
            <TableCard
              faxCardData={filteredFaxes ?? []}
              onDownloadFax={(fax, downloadLink) =>
                onDownloadFax(fax, downloadLink, dispatch, user, navigation)
              }
              setSentFaxData={setSentFaxData}
              setDeleteId={setDeleteId}
              isLoading={isLoading}
              tabKeyName="sent-fax"
              resendFax={onResendFax}
            />
            {!isLoading && (
              <div className="mobile-pagination">
                <Pagination
                  size="small"
                  current={filter?.page ?? 1}
                  pageSize={parseInt(filter?.per_page) ?? 10}
                  total={sentFaxList?.total_faxes ?? 0}
                  onChange={(page, pageSize) => {
                    setFilter({
                      ...filter,
                      page: page,
                      per_page: pageSize,
                    });
                  }}
                  showSizeChanger={true}
                  onShowSizeChange={(page, pageSize) => {
                    setFilter({
                      ...filter,
                      page: page,
                      per_page: pageSize,
                    });
                  }}
                  showTotal={(total, range) => `${range[1]}/ ${total}`}
                />
              </div>
            )}
          </div>
          <div className="mobile-table-block mobile-hide">
            <Table
              data={filteredFaxes ?? []}
              columns={columns}
              isLoading={isLoading}
              pagination={true}
              pageSize={parseInt(filter?.per_page) ?? 10}
              total={sentFaxList?.total_faxes ?? 0}
              currentPage={filter?.page ?? 1}
              handlePageChange={(pagination: any) => {
                setFilter({
                  ...filter,
                  page: pagination.current,
                  per_page: pagination.pageSize,
                });
              }}
              onRowClick={(record: any) => {
                setSentFaxData(record);
              }}
              rowClassName="clickable-rows"
            />
          </div>
        </FaxPageStyle>
      </>
    );
};

export default SentFax;
